import { useTranslation } from 'react-i18next';
import { toFaDigits } from '../lib/jalali';

const STEP_KEYS = [
  'common.stepSelectFlight',
  'common.stepPassengers',
  'common.stepServices',
  'common.stepPayment',
  'common.stepTicket',
] as const;

/** `current` is the zero-based index of the active step; pass STEP_KEYS.length when all are done. */
export function BookingSteps({ current }: { current: number }) {
  const { t, i18n } = useTranslation();
  const isFa = i18n.language.startsWith('fa');

  return (
    <nav className="booking-steps" aria-label={t('common.bookingProgress')}>
      <ol>
        {STEP_KEYS.map((key, index) => {
          const state = index < current ? 'done' : index === current ? 'current' : 'todo';
          return (
            <li
              key={key}
              className={`booking-steps__item is-${state}`}
              aria-current={state === 'current' ? 'step' : undefined}
            >
              <span className="booking-steps__dot" aria-hidden="true">
                {state === 'done' ? (
                  <svg viewBox="0 0 20 20" width="14" height="14" focusable="false">
                    <path
                      fill="currentColor"
                      d="M8.1 13.7 4.6 10.2l1.3-1.3 2.2 2.2 5.9-5.9 1.3 1.3-7.2 7.2z"
                    />
                  </svg>
                ) : isFa ? (
                  toFaDigits(index + 1)
                ) : (
                  index + 1
                )}
              </span>
              <span className="booking-steps__label">{t(key)}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
